import { NgModule } from '@angular/core';
import { PageComponent } from './page.component';

@NgModule({
  declarations: [PageComponent],
  exports: [PageComponent],
})
export class PageModule {}
